import { toCamelCaseProperties } from '@/utils/fn';
import UmbracoBase from './UmbracoBase';

export default class TextAndImage extends UmbracoBase {
	constructor(args) {
		// Inheriting form UmbracoBase
		super(args);

		this.componentName = 'text-and-image';
		this.images = new Images(args);
		this.link = args.link || [];
		this.tagTitle = args.tagTitle;
		this.text = args.text;
		this.title = args.title;
		this.swapImagePosition = args.swapImagePosition;
	}
}

class Images {
	constructor(args) {
		args = toCamelCaseProperties(args) || {};

		this.topImage = args.topImage;
		this.topImageAltText = args.topImageAltText;
		this.middleImage = args.middleImage;
		this.middleImageAltText = args.middleImageAltText;
		this.bottomImage = args.bottomImage;
		this.bottomImageAltText = args.bottomImageAltText;
	}
}
